import React, { Suspense, useContext, useEffect, useState, useRef } from "react";
import "../../../index.css";
import "../../../App.scss";
import { Outlet } from 'react-router-dom';
import Headers from "./Header";
import Sidemenu from "./Sider";
import { Layout, FloatButton } from 'antd';
import { COOKIE, getCookie } from "../../../Services/Cookie";
import { fetchApi } from "../../../Services/Api";
import { isArray } from "highcharts";
// import constants from "../../../Constants/constants";
import { loadSession } from "../../../GlobalFunctions/GlobalFunctions";
import { Spinner } from "react-bootstrap";
import ContactUsWithFloater from '../../Common/Floater'; 
import { UserContext } from "../../../Context";
import ScrollToTop from "../../Common/ScrollToTop";

const Layouts = () => {
  const scrollRef = useRef(null);
  const { setProfileImage, setSession } = useContext(UserContext);
  const userType = getCookie(COOKIE.UserId);
  const [data, setData] = useState([]);
  // const [maxYear, setMaxYear] = useState(0);
  // Nothing below renders until the session is fetched -- see Views/Common/Layout.js.
  const [sessionReady, setSessionReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const settle = (session) => {
      if (cancelled) return;
      setSessionReady(true);
      if (session) {
        setSession(session);
        setProfileImage(session.profileImage || '');
        notificationsList();
        // getMaxYear();
      }
    };
    loadSession().then(settle).catch(() => settle(null));
    return () => { cancelled = true; };
  }, [userType]);

  // const getMaxYear = () => {
  //   const currentMaxYear = constants.StudentYearList[constants.StudentYearList.length - 1].id;
  //   fetchApi(`/get-max-year`, "GET").then((res) => {
  //     if (res?.code === "200") {
  //       setMaxYear(res?.data?.max_year || currentMaxYear);
  //     } else setMaxYear(currentMaxYear)
  //   }).catch(() => {
  //     setMaxYear(currentMaxYear)
  //   });
  // }

  const notificationsList = () => {
    const payload = { isStudent: userType };
    fetchApi(`/get-all-notifications`, "POST", payload).then((res) => {
      if(res?.code === "200") {
        if(isArray(res?.data) && res?.data?.length > 0) {
          setData(res?.data);
          return
        }
      }
      setData([]);
    }).catch(() => {})
  };
  
  const updateNotificationData = () => {
    notificationsList();
  };

  const notificationCount = data?.length;

  const fallback = () => (
    <div className="mx-auto min-vh-100 d-flex justify-content-center align-items-center p-3 p-md-0">
      <Spinner animation="border" role="output" className="d-flex justify-content-center align-items-center position-absolute z-3"></Spinner>
    </div>
  )

  if (!sessionReady) return fallback();

  return (
    <Layout>
      <Sidemenu notificationCount={notificationCount} />
      <Layout>
        <Headers countData={data} updateNotificationData={updateNotificationData} />
        <Suspense fallback={fallback()}>
          <ScrollToTop targetRef={scrollRef} />
          <div ref={scrollRef} className="h-[calc(100vh-50px)] p-3 overflow-y-auto overflow-hidden">
            <Outlet context={[data, updateNotificationData/* , maxYear, getMaxYear */]}/>
            <FloatButton.Group shape="circle" style={{ insetInlineEnd: 24 }}>
              <FloatButton.BackTop className='right-2.5 top-btn' type='primary' visibilityHeight={100} target={() => scrollRef.current} />
              <ContactUsWithFloater />
            </FloatButton.Group>
          </div>
        </Suspense>
      </Layout>
    </Layout>
  );
};
export default Layouts;